import gsap from "gsap";
import { api } from "@/services/api";
import { toastr } from "@/plugins/toast";

export function efeito(id_element, telaY, efeito = '') {
  switch (efeito) {
    case 'fadeInUp':
      var ef = 'animate__fadeInUp'
      break;
    case 'flipInX':
      var ef = 'animate__flipInX'
      break;
    case 'lightSpeedInLeft':
      var ef = 'animate__lightSpeedInLeft'
      break;
    case 'bounceInDown':
      var ef = 'animate__bounceInDown'
      break;
    case 'bounceInLeft':
      var ef = 'animate__bounceInLeft'
      break;
    case 'fadeInRightBig':
      var ef = 'animate__fadeInRightBig'
      break;
    case 'zoomInDown':
      var ef = 'animate__zoomInDown'
      break;
    case 'zoomIn':
      var ef = 'animate__zoomIn'
      break;
    default:
      var ef = 'animate__zoomInDown'
      break;
  }

  if (!telaY) {
    telaY = (window.screen.height * 0.75)
  }

  var el = document.getElementById(id_element);
  var coordenadas = el.getBoundingClientRect();

  if (coordenadas.top < telaY) {
    el.classList.add(ef)
    setTimeout(() => {
    }, 2000);
  }
  if (coordenadas.top > window.screen.height) {
    el.classList.remove(ef)
  }
}

export function remove_acento(text) {
  text = text.toLowerCase();
  text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
  text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
  text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
  text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
  text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
  text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
  text = text.replace(new RegExp('[ ,.!?/:;´`^~]', 'gi'), '-');
  return text // text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");;
}

export function alertou(conteudo = "Funcionou alertou") {
  console.log(conteudo)
}

export function filtro_loading(opt = true) {
  const loading = document.querySelector('#load')
  if (opt) {
    loading.classList.remove('d-none');
  } else {
    loading.classList.add('d-none');
  }
}

export function limita_caracteres(texto, qtd_caracter) {
  return texto.substring(0, qtd_caracter)
}

export function copiar_texto(texto) {
  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      return true;
    } catch (err) {
      return false
    }
  }
  return copyContent()
}

export function bloqueia_campos(opt = true, processo = '') {
  const campos = document.querySelectorAll('fieldset')
  const loading = document.querySelector('#load')
  if (opt) {
    loading.classList.remove('d-none');
    campos.forEach((campo) => {
      campo.setAttribute("disabled", true);
    })
  } else {
    campos.forEach((campo) => {
      campo.removeAttribute('disabled')
    })
    loading.classList.add('d-none');
  }
}

export function saudacao() {
  const now = new Date;
  var hora = now.getHours();
  if (hora >= 0 && hora < 12) {
    var saudacao = "Bom dia"
  } else if (hora >= 12 && hora < 18) {
    var saudacao = "Boa tarde"
  } else {
    var saudacao = "Boa noite"
  }

  return saudacao;
}

export function data_formatada(date, format) {
  const map = {
    mm: date.getMonth() + 1,
    dd: date.getDate(),
    aa: date.getFullYear().toString().slice(-2),
    aaaa: date.getFullYear()
  }

  return format.replace(/mm|dd|aa|aaaa/gi, matched => map[matched])
}

export function data_hoje(dias_diferencial = 0, retorno = 'banco') {
  const data = new Date();

  if (dias_diferencial != 0 && Number.isInteger(dias_diferencial)) {
    data.setDate(data.getDate() + dias_diferencial);
  }
  let dia = data.getDate();
  dia = (dia < 10 ? '0' + dia : dia);
  let mes = data.getMonth() + 1;
  mes = (mes < 10 ? '0' + mes : mes);
  let ano = data.getFullYear();

  switch (retorno) {
    case 'banco':
      var completo = ano + '-' + mes + '-' + dia;
      break;
    case 'exibir':
      var completo = dia + '/' + mes + '/' + ano;
      break;
    default:
      var completo = ano + '-' + mes + '-' + dia;
      break;
  }

  return completo;
}

export function class_placeholder(ativo = true) {
  return (ativo ? 'placeholder' : '')
}

export function porcentagem(valor_total, valor_compara) {
  return ((valor_compara / valor_total) * 100).toFixed(0);
  // return (((valor_total / 100) * (valor_compara / 100)) * 100).toFixed(2)
}

export function removerTags(html) {
  return html.replace(/<[^>]*>/g, '');
}

export async function busca_cep(cep) {
  const link = 'https://brasilapi.com.br/api/cep/v1/' + cep;
  try {
    var dados = {}
    var local = await api.fullget(link)
    dados.status = local.status
    if (local.status == 200) {
      dados.rua = local.street;
      dados.bairro = local.neighborhood;
      dados.cidade = local.city;
      dados.estado = local.state;
    } else {
      dados.rua = '';
      dados.bairro = '';
      dados.cidade = '';
      dados.estado = '';
      toastr.erro("CEP não encontrado, verifique o cep digitado e tente novamente.")
    }

  } catch (error) {
    dados.status = 'erro: ' + error;
    dados.rua = '';
    dados.bairro = '';
    dados.cidade = '';
    dados.estado = '';
    toastr.erro("Erro na solicitação, verifique o cep digitado e tente novamente.")
  }

  return dados
}

export function mensagem_request(dados, toast = null) {
  if (dados.status >= 200 && dados.status < 300) {
    toastr.sucesso(dados.message)
    if (dados?.messages) {
      for (const key in dados.messages) {
        toastr.sucesso(dados.messages[key]);
      }
    }
  } else if (dados.status >= 300 && dados.status < 400) {
    toastr.alerta(dados.message)
  } else {
    if (dados?.error) {
      for (const key in dados.error) {
        toastr.erro(dados.error[key]);
      }
    }
    toastr.erro(dados.message)
  }
}

export async function preview_img(event, img_prev) {
  // Reference to the DOM input element
  var input = event.target;
  // Ensure that you have a file before attempting to read it

  if (input.files && input.files[0]) {
    // create a new FileReader to read this image and convert to base64 format
    var reader = await new FileReader();
    // Define a callback function to run, when FileReader finishes its job
    reader.onload = (e) => {
      // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
      // Read image as base64 and set to imageData
      document.querySelector(img_prev).src = e.target.result;
      // console.log("Passou",e.target.result);
      return e.target.result
    }
    // Start the reader job - read file as a data url (base64 format)
    reader.readAsDataURL(input.files[0]);
    // files = input.files[0]
  } else {
    // files = null;
    return false
  }
}

export function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
}

export function meta_default(titulo) {
  return [
    { name: 'og:image', content: process.env.VUE_APP_img_shared },
    { name: 'og:title', content: titulo },
    { name: 'og:description', content: process.env.VUE_APP_description },
    { name: 'og:url', content: process.env.VUE_APP_site + window.location.pathname },
  ]
}

export function muda_titulo(metaInfo) {
  document.title = (metaInfo != undefined ? metaInfo.title + ' | ' : '') + process.env.VUE_APP_nome_site
  if (metaInfo && metaInfo.meta) {
    metaInfo.meta.forEach(element => {
      const metaElement = document.querySelector('meta[property="' + element.name + '"]');
      if (metaElement) {
        metaElement.remove();
      }

      const metaItem = document.createElement('meta');
      metaItem.setAttribute('property', element.name);
      metaItem.setAttribute('content', element.content);
      document.head.prepend(metaItem);
    });
  }
}